import { EventContentArg } from '@fullcalendar/core';
import { eventTypeChecker } from './eventTypeChecker';
import { renderSubscribedEvent } from './formatters/subscribedEventFormatter';
import { renderBookingEvent } from './formatters/bookingEventFormatter';

/**
 * 통합 이벤트 라우터 (메인 함수)
 * - OCP: 새로운 이벤트 타입 추가 시 해당 포맷터 파일만 생성하고 여기서 import
 * - SRP: 이벤트 타입에 따른 포맷터 선택만 담당
 *
 * @param eventInfo FullCalendar 이벤트 정보
 * @returns 렌더링할 HTML 객체
 */
export const renderCalendarEvent = (eventInfo: EventContentArg) => {
  // 구독 이벤트인 경우
  if (eventTypeChecker.isSubscribedEvent(eventInfo)) {
    return renderSubscribedEvent(eventInfo);
  }

  // 예약 이벤트인 경우 (기본)
  return renderBookingEvent(eventInfo);
};
